module.exports = __webpack_public_path__ + "img/incein-circle-fill.4f00eb58.svg";